import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../../../Url/NodeBaseURL";
import "./Dashboard.css";
import Repairs from "./Repairs";
import Sales from "./Sales";
import Orders from "./Orders";
import Purchases from "./Purchases";
import URDPurchase from "./URDPurchase";
import Customers from "./Customers";
import Suppliers from "./Suppliers";
import CustomerDashboard from "./CustomerDashboard";
import Estimate from "./Estimate";
import AccountBalanceTable from "./AccountBalanceTable";
import { AuthContext } from "../Login/Context";
import PayablesTable from "./PayablesTable";
import ReceivablesTable from "./ReceivablesTable";
import OrderTable from "./OrderTable";
import InventoryDataCard from "./InventoryDataCard";
// Chart.js imports removed as pie chart is no longer used

function Dashboard() {
  const { authToken, userId, userName } = useContext(AuthContext);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [selectedMobile, setSelectedMobile] = useState(null);
  const navigate = useNavigate();

  // Chart data removed as pie chart is no longer used

  const handleNewSales = () => {
    try {
      // Clear cached data to avoid calculation issues
      localStorage.clear();
    } catch (e) {
      // noop
    }
    window.open("/sales", "_blank");
  };

  // Unused navigation functions removed

  useEffect(() => {
    const cleanupEstimates = async () => {
      try {
        const cleanupResponse = await axios.get(`${baseURL}/cleanup-old-estimates`);
        console.log("Old estimates cleanup completed:", cleanupResponse.data);
      } catch (cleanupError) {
        console.error("Error cleaning up old estimates:", cleanupError);
      }
    };
    cleanupEstimates();
  }, []);
  return (
    <div className="main-container" style={{ backgroundColor: "#b7721834" }}>
      <div className="dashboard-header">
        <h2 style={{ marginTop: "25px", marginLeft: "15px" }}>Dashboard</h2>
        <CustomerDashboard onSelectCustomer={setSelectedMobile} />
      </div>
      <div className="dashboard-container">
        <div className="row-cards">
          <div className="metric-card">
            <Estimate selectedCustomerMobile={selectedMobile} />
            <a
              style={{ marginRight: "100px" }}
              href="#"
              className="btn-link"
              onClick={(e) => {
                e.preventDefault();
                console.log("Selected Customer Mobile:", selectedMobile);
                navigate("/estimatetable/v2", {
                  state: { mobile: selectedMobile },
                });
              }}
            >
              Details
            </a>
            <a
              href="/estimates/v2"
              className="btn-link"
              target="_blank"
            >
              New
            </a>
          </div>
          <div className="metric-card">
            <Sales selectedCustomerMobile={selectedMobile} />
            <a
              style={{ marginRight: "100px" }}
              href="#"
              className="btn-link"
              onClick={(e) => {
                e.preventDefault();
                console.log("Selected Customer Mobile:", selectedMobile);
                navigate("/salestable", { state: { mobile: selectedMobile } });
              }}
            >
              Details
            </a>
            {/* <a

              href="#"
              className="btn-link"
              onClick={(e) => {
                e.preventDefault();
                navigate("/sales", { state: { mobile: selectedMobile } });
              }}
            >
              New
            </a> */}
            <a
              href="#"
              className="btn-link"
              onClick={(e) => {
                e.preventDefault();
                handleNewSales();
              }}
            >
              New
            </a>
          </div>
          <div className="metric-card">
            <Purchases selectedCustomerMobile={selectedMobile} />
            <a
              style={{ marginRight: "100px" }}
              href="#"
              className="btn-link"
              onClick={(e) => {
                e.preventDefault();
                console.log("Selected Customer Mobile:", selectedMobile);
                navigate("/purchasetable", {
                  state: { mobile: selectedMobile },
                });
              }}
            >
              Details
            </a>
            <a
              href="#"
              className="btn-link"
              onClick={(e) => {
                e.preventDefault();
                navigate("/purchase", { state: { mobile: selectedMobile } });
              }}
            >
              New
            </a>
          </div>
          <div className="metric-card">
            <Customers selectedCustomerMobile={selectedMobile} />
          </div>
          <div className="metric-card">
            <Suppliers selectedCustomerMobile={selectedMobile} />
          </div>
        </div>
        <div className="row-cards" style={{ marginTop: "15px" }}>
          <div className="metric-card">
            <Repairs selectedCustomerMobile={selectedMobile} />
            <a
              style={{ marginRight: "100px" }}
              href="#"
              className="btn-link"
              onClick={(e) => {
                e.preventDefault();
                console.log("Selected Customer Mobile:", selectedMobile);
                navigate("/repairstable", {
                  state: { mobile: selectedMobile },
                });
              }}
            >
              Details
            </a>
            <a
              href="#"
              className="btn-link"
              onClick={(e) => {
                e.preventDefault();
                navigate("/repairs", { state: { mobile: selectedMobile } });
              }}
            >
              New
            </a>
          </div>
          <div className="metric-card">
            <Orders selectedCustomerMobile={selectedMobile} />
            <a
              style={{ marginRight: "100px" }}
              href="#"
              className="btn-link"
              onClick={(e) => {
                e.preventDefault();
                console.log("Selected Customer Mobile:", selectedMobile);
                navigate("/orderstable", { state: { mobile: selectedMobile } });
              }}
            >
              Details
            </a>
            <a
              href="#"
              className="btn-link"
              onClick={(e) => {
                e.preventDefault();
                console.log("Selected Customer Mobile:", selectedMobile);
                window.open(`/orders?mobile=${selectedMobile}`, "_blank");
              }}
            >
              New
            </a>
          </div>
          <div className="metric-card">
            <URDPurchase selectedCustomerMobile={selectedMobile} />
            <a
              style={{ marginRight: "100px" }}
              href="#"
              className="btn-link"
              onClick={(e) => {
                e.preventDefault();
                console.log("Selected Customer Mobile:", selectedMobile);
                navigate("/urdpurchasetable", {
                  state: { mobile: selectedMobile },
                });
              }}
            >
              Details
            </a>
            <a
              href="#"
              className="btn-link"
              onClick={(e) => {
                e.preventDefault();
                navigate("/urd_purchase", {
                  state: { mobile: selectedMobile },
                });
              }}
            >
              New
            </a>
          </div>
          <div
            className="metric-card"
            //onClick={handleClickReceivables}
            style={{ cursor: "pointer" }}
          >
            <h3
              style={{
                margin: "0 0 10px 0",
                fontSize: "20px",
                textAlign: "center",
                color: "#b77318",
              }}
            >
              Receivables
            </h3>
            <ReceivablesTable />
          </div>
          <div
            className="metric-card"
            //onClick={handleClickPayables}
            style={{ cursor: "pointer" }}
          >
            <h3
              style={{
                margin: "0 0 10px 0",
                fontSize: "20px",
                textAlign: "center",
                color: "#b77318",
              }}
            >
              Payables
            </h3>
            <PayablesTable />
          </div>
        </div>
        <div
          className="row3-card"
          style={{ marginTop: "15px", marginBottom: "15px" }}
        >
          {/* <div className="metric-card">
            <Bar data={barData} options={{ responsive: true, maintainAspectRatio: false }} />
          </div> */}
          <div className="metric-card" style={{width: "20%", padding: "12px" }}>
            <h3
              style={{
                margin: "0 0 10px 0",
                fontSize: "20px",
                textAlign: "center",
                color: "#b77318",
              }}
            >
              Top Customers
            </h3>
            <AccountBalanceTable />
          </div>
          <div className="metric-card" style={{ width: "34%", padding: "12px" }}>
            <h3
              style={{
                margin: "0 0 10px 0",
                fontSize: "20px",
                textAlign: "center",
                color: "#b77318",
              }}
            >
              Pending Orders
            </h3>
            <OrderTable />
          </div>
          {/* <div className="metric-card">
            <Pie
              data={pieDataReceivablesPayables}
              options={{ responsive: true, maintainAspectRatio: false }}
            />
          </div> */}
          {/* <div className="metric-card">
            <Line data={lineDataRevenue} options={{ responsive: true, maintainAspectRatio: false }} />
          </div> */}
          <div className="metric-card" style={{width: "43%", padding: "12px" }}>
            <h3
              style={{
                margin: "0 0 10px 0",
                fontSize: "20px",
                textAlign: "center",
                color: "#b77318",
              }}
            >
              Inventory Overview
            </h3>
            <InventoryDataCard />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
